
import { Component, Vue, Prop } from 'vue-property-decorator';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';
import imageConvert from '@/utils/image';

const { currency } = api;

@Component({
  components: { },
})
export default class VirtualCurrencyForm extends Vue {
  @Prop({ default: '' }) currencyId!: string;

  private loading: boolean = false;

  private valid: boolean = false;

  private pic: string = '';

  private form = {
    name: '',
    shortCode: '',
    pic: '',
  }

  private get isEdit() {
    return !!this.currencyId;
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private rules = {
    name: [this.requiredRule('名稱')],
    shortCode: [this.requiredRule('簡稱')],
    pic: [...this.requiredFileRule()],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private requiredFileRule() {
    return [
      (v: any) => !!v || !!this.pic || '檔案 為必填',
      (v: any) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
    ];
  }

  private changePic(event: any) {
    if (event) {
      this.form.pic = event;
      this.pic = URL.createObjectURL(event);
    }
  }

  private clearImage() {
    this.pic = '';
    this.form.pic = '';
  }

  private async cancel() {
    await this.$router.back();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const data = {
        ...this.form,
        pic: await imageConvert(this.form.pic as any),
      };
      const { status } = this.isEdit
        ? await currency.edit(this.currencyId, data)
        : await currency.add(data);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        this.$router.back();
      }
    }
  }

  private async mounted() {
    if (this.isEdit) {
      const { data } = await currency.get(this.currencyId);
      this.form = data;
      this.pic = this.form.pic;
    }
  }
}
